<article
    class="list-item"
    [attr.aria-label]="listItem.title"
>
    <div uiItemContentHost></div>
</article>
